import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Department } from '@app/shared/models/department';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ClientService } from '@app/core/services/client.service';
import { OP } from '@app/core/services/base/base-service-with-bundle.service';
import { SmpError } from '@app/shared/models/smp-error';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'department-edit',
    templateUrl: './department.component.html',
    styleUrls: ['./department.component.scss']
})
export class DepartmentComponent extends BaseComponent implements OnInit {

    @Input()
    public department?: Department;

    @Output()
    public saved = new EventEmitter<Department>();

    @Output()
    public canceled = new EventEmitter<any>();

    public company_name: UntypedFormControl;

    get hasChanges(): boolean {
        return this.company_name.value !== this.department.companyname;
    }

    constructor(protected clientService: ClientService) {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();

        if (!this.department) {
            this.department = new Department();
        }

        this.company_name = new UntypedFormControl(
            {
                value: this.department.companyname,
                disabled: this.disabled
            },
            {
                updateOn: 'change',
                validators: [Validators.required],
            });
    }


    // MAIN BUTTONS **************************************************************************************************

    public submit(): void {
        this.formToModel();

        if (this.valid()) {
            if (this.department.id) {
                this.patchDepartmentName();
            } else {
                this.createDepartment();
            }
        }
    }

    private createDepartment(): void {
        this.clientService.createDepartment(this.department)
            .subscribe((result) => {
                this.saved.emit(result);
            }, err => this.handleError(err));
    }

    private patchDepartmentName(): void {
        const patch = {
            op: OP.replace,
            path: 'companyname',
            value: this.department.companyname
        };

        this.clientService.patchDepartment(this.department, [patch])
            .subscribe((result) => {
                this.saved.emit(result);
            }, err => this.handleError(err));
    }

    public cancel(): void {
        this.canceled.emit();
    }


    // VALIDATION ****************************************************************************************************

    protected handleError(error: HttpErrorResponse | Error | string): void {
        super.handleError(error);

        if (error instanceof HttpErrorResponse && (<SmpError>error.error).additional_code === 'validation.duplicate.companyname') {
            this.company_name.setErrors( { exists: true });
        }
    }

    protected valid(): boolean {
        this.company_name.markAsTouched();
        return this.company_name.valid;
    }

    protected formToModel(): void {
        this.department.companyname = this.company_name.value;
    }

    public getCompanyNameError(): string {
        return this.company_name.hasError('required') ? marker('department_management.error.company_name.required') :
               this.company_name.hasError('exists') ? marker('department_management.error.company_name.exists') :
               '';
    }
}
